import { Modal } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { FinishReasonForm, FinishReasonFormValues } from "./FinishReasonForm"

export interface FinishReasonFormInModalProps {
  initialValues: FinishReasonFormValues
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: FinishReasonFormValues) => void
}
export function FinishReasonModal({
  initialValues,
  isOpen,
  onClose,
  onSubmit,
}: FinishReasonFormInModalProps) {
  const { t } = useTranslation("benefits/CancellationReasonModal")

  return (
    <Modal data-testid="finish-reason-modal" isOpen={isOpen} onRequestClose={onClose} size="sm">
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content className="!overflow-visible">
        <FinishReasonForm initialValues={initialValues} onSubmit={onSubmit} onCancel={onClose} />
      </Modal.Content>
    </Modal>
  )
}
